import React from "react";
var __jsx = React.createElement;

var NextApp = function NextApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      children = _ref.children;
  return __jsx(React.Fragment, null, children, __jsx(Component, pageProps));
};

export default NextApp;